<template lang="pug">
.container
  .grid.is-ultrawide-5.is-widescreen-6.is-desktop-7.is-tablet-8.is-center
    LoginForm(@success="onSuccess")

</template>

<script>
import Cookie from 'js-cookie';
import LoginForm from '@/components/LoginForm';
import Store from '@/store';

export default {
  name: 'LoginView',
  components: {
    // SignupForm,
    // LockForm,
    LoginForm
  },
  data: () => ({
    method: null
  }),
  methods: {
    onSuccess ({ user, token }) {
      Store.setUser(user);
      Store.setToken(token);
      Cookie.set('auth', token, { expires: 30 });
    }
  }
};
</script>
